export const RootPath = "/:IMEI?/:Offering?";
